var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgAdvice = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("g", {
    id: "Desktop---Chatlist",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Chatlist---Dica-contextual---6---Troca",
    transform: "translate(-607.000000, -530.000000)",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }, React.createElement("g", {
    id: "box-dicas",
    transform: "translate(592.875000, 510.000000)"
  }, React.createElement("g", {
    id: "0:-Icons-/-Idea-6",
    transform: "translate(14.125000, 20.000000)"
  }, React.createElement("path", {
    d: "M12,1.32563943e-15 C5.372583,-1.32563943e-15 3.75597839e-15,5.372583 0,12 C-3.75597839e-15,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C23.989044,5.37712642 18.6228736,0.0109559755 12,1.32563943e-15 Z M12,23.0149254 C5.92341588,23.0149229 0.996859617,18.0898478 0.995029873,12.013264 C0.993200129,5.93668016 5.91678948,1.00863909 11.9933725,1.00497712 C18.0699555,1.00131515 22.9994809,5.92341837 23.0049751,12 C22.9940223,18.0733373 18.0733373,22.9940223 12,23.0049751 L12,23.0149254 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(4.000000, 4.000000)"
  }, React.createElement("path", {
    d: "M8,3.13333333 C7.82608696,3.13333333 7.65217391,3.13333333 7.47826087,3.16666667 C5.49565217,3.36666667 3.82608696,4.9 3.51304348,6.8 C3.30434783,8.03333333 3.65217391,9.23333333 4.4173913,10.1666667 C5.28695652,11.2 5.73913043,12.4 5.73913043,13.5666667 C5.73913043,13.7666667 5.87826087,13.9 6.08695652,13.9 L9.91304348,13.9 C10.1217391,13.9 10.2608696,13.7666667 10.2608696,13.5666667 C10.2608696,12.3 10.6782609,11.1666667 11.4434783,10.3 C12.1391304,9.5 12.5217391,8.5 12.5217391,7.46666667 C12.5565217,5.1 10.5043478,3.13333333 8,3.13333333 Z M10.9217391,9.86666667 C10.1217391,10.7666667 9.63478261,11.9666667 9.56521739,13.2333333 L6.43478261,13.2333333 C6.36521739,12 5.87826087,10.8 4.97391304,9.73333333 C4.31304348,8.93333333 4.03478261,7.9 4.20869565,6.86666667 C4.45217391,5.26666667 5.87826087,3.96666667 7.54782609,3.8 C7.68695652,3.8 7.86086957,3.76666667 8,3.76666667 C10.1217391,3.76666667 11.8608696,5.43333333 11.8608696,7.46666667 C11.8608696,8.36666667 11.5130435,9.2 10.9217391,9.86666667 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M8,4.53333333 C7.79130435,4.53333333 7.65217391,4.66666667 7.65217391,4.86666667 C7.65217391,5.06666667 7.79130435,5.2 8,5.2 C9.32173913,5.2 10.4,6.23333333 10.4,7.5 C10.4,7.7 10.5391304,7.83333333 10.7478261,7.83333333 C10.9565217,7.83333333 11.0956522,7.7 11.0956522,7.5 C11.0956522,5.86666667 9.70434783,4.53333333 8,4.53333333 Z",
    id: "Path",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M15.5826087,7.26666667 L13.5304348,7.26666667 C13.3217391,7.26666667 13.1826087,7.4 13.1826087,7.6 C13.1826087,7.8 13.3217391,7.93333333 13.5304348,7.93333333 L15.5826087,7.93333333 C15.7913043,7.93333333 15.9304348,7.8 15.9304348,7.6 C15.9304348,7.4 15.7565217,7.26666667 15.5826087,7.26666667 Z",
    id: "Path",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M2.85217391,7.6 C2.85217391,7.4 2.71304348,7.26666667 2.50434783,7.26666667 L0.417391304,7.26666667 C0.208695652,7.26666667 0.0695652174,7.4 0.0695652174,7.6 C0.0695652174,7.8 0.208695652,7.93333333 0.417391304,7.93333333 L2.46956522,7.93333333 C2.67826087,7.93333333 2.85217391,7.76666667 2.85217391,7.6 Z",
    id: "Path",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M8,2.53333333 C8.20869565,2.53333333 8.34782609,2.4 8.34782609,2.2 L8.34782609,0.333333333 C8.34782609,0.133333333 8.20869565,0 8,0 C7.79130435,0 7.65217391,0.133333333 7.65217391,0.333333333 L7.65217391,2.2 C7.65217391,2.4 7.79130435,2.53333333 8,2.53333333 Z",
    id: "Path",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M11.9304348,4.13333333 C12.0347826,4.13333333 12.1043478,4.1 12.173913,4.03333333 L13.5652174,2.7 C13.7043478,2.56666667 13.7043478,2.36666667 13.5652174,2.23333333 C13.426087,2.1 13.2173913,2.1 13.0782609,2.23333333 L11.6869565,3.56666667 C11.5478261,3.7 11.5478261,3.9 11.6869565,4.03333333 C11.7565217,4.1 11.8608696,4.13333333 11.9304348,4.13333333 Z",
    id: "Path",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M3.79130435,4.03333333 C3.86086957,4.1 3.96521739,4.13333333 4.03478261,4.13333333 C4.13913043,4.13333333 4.20869565,4.1 4.27826087,4.03333333 C4.4173913,3.9 4.4173913,3.7 4.27826087,3.56666667 L2.88695652,2.23333333 C2.74782609,2.1 2.53913043,2.1 2.4,2.23333333 C2.26086957,2.36666667 2.26086957,2.56666667 2.4,2.7 L3.79130435,4.03333333 Z",
    id: "Path",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M9.80869565,14.3 L6.19130435,14.3 C5.9826087,14.3 5.84347826,14.4333333 5.84347826,14.6333333 C5.84347826,14.8333333 5.9826087,14.9666667 6.19130435,14.9666667 L9.80869565,14.9666667 C10.0173913,14.9666667 10.1565217,14.8333333 10.1565217,14.6333333 C10.1565217,14.4333333 9.9826087,14.3 9.80869565,14.3 Z",
    id: "Path",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M9.80869565,15.3333333 L6.19130435,15.3333333 C5.9826087,15.3333333 5.84347826,15.4666667 5.84347826,15.6666667 C5.84347826,15.8666667 5.9826087,16 6.19130435,16 L9.80869565,16 C10.0173913,16 10.1565217,15.8666667 10.1565217,15.6666667 C10.1565217,15.4666667 9.9826087,15.3333333 9.80869565,15.3333333 Z",
    id: "Path",
    fillRule: "nonzero"
  })))))));
};
export default SvgAdvice;